import React from 'react';
import PropTypes from 'prop-types';
import { moneyFormat } from '@4beefopag/4bee-fopag-core/dist/util';
import { TabelaLancamentos } from './styles';

function CooperatorTotals({ cooperator }) {
  return (
    <TabelaLancamentos>
      <tbody>
        <tr>
          <td
            colSpan="6"
            aria-hidden="true"
          >
            &nbsp;
          </td>
        </tr>
        <tr>
          <td
            rowSpan="2"
            className="center-align"
          >
            <b>C/C N° {cooperator.ccn}</b>
          </td>
          <td width="25%">
            <b>Total de Créditos / Débitos</b>
          </td>
          <td
            width="10%"
            className="right-align"
          >
            {moneyFormat(cooperator.totalCreditoAtual)}
          </td>
          <td
            width="10%"
            className="right-align"
          >
            {moneyFormat(cooperator.totalCreditoAcumulado)}
          </td>
          <td
            width="10%"
            className="right-align"
          >
            {moneyFormat(cooperator.totalDebitoAtual)}
          </td>
          <td
            width="10%"
            className="right-align"
            style={{ paddingRight: '5px' }}
          >
            {moneyFormat(cooperator.totalDebitoAcumulado)}
          </td>
        </tr>
        <tr>
          <td>
            <b>Total Líquido</b>
          </td>
          <td
            className="right-align"
            colSpan="4"
            style={{ paddingRight: '5px' }}
          >
            {moneyFormat(cooperator.totalLiquido)}
          </td>
        </tr>
        <tr>
          <td
            colSpan="6"
            aria-hidden="true"
          >
            &nbsp;
          </td>
        </tr>
      </tbody>
    </TabelaLancamentos>
  );
}

CooperatorTotals.propTypes = {
  cooperator: PropTypes.shape({
    ccn: PropTypes.string,
    totalCreditoAtual: PropTypes.number,
    totalCreditoAcumulado: PropTypes.number,
    totalDebitoAtual: PropTypes.number,
    totalDebitoAcumulado: PropTypes.number,
    totalLiquido: PropTypes.number,
  }).isRequired,
};

export default CooperatorTotals;
